import React from "react";
import "./styles/About.css";
import { Link } from "react-router-dom";



const About = () => {
  return (
    <div className="about-container">
      <div className="about-header">
        <h1 className=" coloricon">Who Are We?</h1>
        <p>
          {" "}
          "Weekly Cybersecurity Info" is a platform dedicated to providing you
          with the latest information on cybersecurity threats, vulnerabilities,
          and tips for protecting your personal and professional data.
        </p>
      </div>

      <div className="about-content">
        <div className="about-description">
          <p>
            In an ever-evolving digital world, cybersecurity is more important
            than ever. Our platform is dedicated to providing you with the
            latest information on threats, vulnerabilities, and tips for
            protecting your personal and professional data. Our goal: to help
            you navigate a secure digital environment with peace of mind.
          </p>
          <p>
            We regularly publish articles, analyses, and alerts on the latest
            trends in cybersecurity. Whether you are an individual or a
            professional, you will find useful advice and essential information
            on our platform to better protect yourself from cyber threats.
          </p>
        </div>

        <div className="features ">
          <h3 className=" coloricon">What You Will Find on Our Website</h3>
          <ul>
            <li>
              <i className="fas fa-newspaper coloricon" ></i>
              <span>Detailed articles on the latest cybersecurity threats</span>
            </li>
            <li>
              <i className="fas fa-bell  coloricon"></i>
              <span>
                Alerts and notifications to inform you about emerging risks
              </span>
            </li>
            <li>
              <i className="fas fa-book-reader  coloricon"></i>
              <span>
                Practical advice and guides to improve your online security
              </span>
            </li>
            <li>
              <i className="fas fa-user-shield  coloricon" ></i>
              <span>Regular updates on vulnerabilities and recent attacks</span>
            </li>
          </ul>
        </div>
        <div className="mission">
          <h3 className=" coloricon">Our Mission</h3>
          <div className="mission-content">
            <p>
              Our mission is to make cybersecurity information accessible and
              understandable for everyone. Through our articles, we aim to
              demystify complex cybersecurity topics and provide practical
              solutions for each user. We believe that the key to better
              cybersecurity lies in awareness and prevention.
            </p>

            <img
              src={require("../assets/mission.jpg")}
              alt="Representation of our mission"
              className="mission-image"
            />
          </div>
        </div>

        <div className="why-choose-us">
          <h3 className=" coloricon">Why Follow Our Newsletter?</h3>
          <ul>
            <li>
              <i className="fas fa-check-circle coloricon"></i>
              <span>
                Receive updated articles on cybersecurity threats and solutions.
              </span>
            </li>
            <li>
              <i className="fas fa-check-circle  coloricon"></i>
              <span>
                Stay informed about the latest vulnerabilities and attacks.
              </span>
            </li>
            <li>
              <i className="fas fa-check-circle  coloricon"></i>
              <span>
                Access resources and practical advice to protect your data.
              </span>
            </li>
            <li>
              <i className="fas fa-check-circle  coloricon"></i>
              <span>
                A simple, easy-to-navigate site with clear and accessible
                information for all.
              </span>
            </li>
          </ul>
        </div>

        <div className="cta">
          <h3>Join Our Community and Stay Informed!</h3>
          <p>
            Sign up for our newsletter to receive the latest articles and alerts
            directly in your inbox. Cybersecurity is an ever-evolving field, and
            staying up-to-date is essential for your security.
          </p>
          <Link to="/home">
            <button className="cta-button ">Subscribe to the Newsletter</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
